export enum ApprovalTypeEnum {
  ID = 1,
  Address = 2,
  Payment = 3,
  SourceOfWealthQuestionnaire = 4,
  SourceOfWealthSupportingDocuments = 5,
  SourceOfFunds = 6,
  SocialSecurityNumber = 7,
}
